import { createSelector } from "reselect";
import { convertTaskToEvent } from "./actions";
// import { get } from "lodash";
import moment from "moment";

export const selectJobpacks = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.jobpacks;
};

export const selectFocussedEvent = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.focussedEvent;
};

export const selectFocussedEventIndices = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.focussedEventIndices;
};

export const selectUsers = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.users;
};

export const selectMachines = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.machines;
};

export const selectEquipment = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.equipment;
};

export const selectTracks = ({ Roster_reducer }) => {
    const tracks = Roster_reducer.MainReducer.tracks;

    if (Array.isArray(tracks) === false) {
        return [];
    }
    return tracks;
};

export const selectShowAddEventModal = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.showAddEventModal;
};

export const selectShowEditEventModal = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.showEditEventModal;
};

export const selectShowAddParentTrackModal = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.showAddParentTrackModal;
};

export const selectShowAddChildTrackModal = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.showAddChildTrackModal;
};

export const selectShowDeleteTrackModal = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.showDeleteTrackModal;
};

export const selectShowEditTrackModal = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.showEditTrackModal;
};

export const selectCreateChildTrackParent = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.createChildTrackParent;
};

export const selectDeletingTrack = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.deletingTrack;
};

export const selectEditingTrack = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.editingTrack;
};

export const selectClickedTimeBlock = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.clickedTimeBlock;
};

export const selectClickedDayTimeBlock = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.clickedDayTimeBlock;
};

export const selectEventRow = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.eventRow;
};

export const selectSelectedDays = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.selectedDays;
};

export const selectTaskRow = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.taskRow;
};

export const selectDragTimeBlockIndex = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.dragTimeBlockIndex;
};

export const selectTrackCount = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.trackCount;
};

export const selectDayRange = ({ Roster_reducer }) => {
    const { start, end } = Roster_reducer.MainReducer;
    return { start, end };
};

export const selectAgendaItemDragging = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.agendaItemDragging;
};

export const selectAgendaItemPosition = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.agendaItemPosition;
};

export const selectUIState = ({ Roster_reducer }) => {
    return Roster_reducer.MainReducer.uiState;
};

export const selectWeekCount = createSelector(
    [selectUIState],
    uiState => {
        if (uiState !== false) {
            return uiState.weekCount;
        }
        return false;
    }
);

const dateKeyToDate = dateKey => {
    return moment(dateKey, "DD/MM/YYYY");
};

const dateWithinRange = (rangeStart, rangeEnd, taskStart, taskEnd) => {
    rangeStart = dateKeyToDate(rangeStart);
    rangeEnd = dateKeyToDate(rangeEnd);

    const tStart = dateKeyToDate(taskStart);
    const tEnd = dateKeyToDate(taskEnd);

    if (tStart < rangeStart && tEnd < rangeStart) {
        return false;
    }

    if (tStart > rangeEnd) {
        return false;
    }

    return true;
};

const getDayRangeFilteredEventsForTasks = (dayRange, tasks) => {
    return tasks
        .map((t, i) => {
            const event = convertTaskToEvent(dayRange.start, t);
            event.row = event.row === false ? 1 : event.row;
            return {
                inRange: dateWithinRange(dayRange.start, dayRange.end, t.start_date, t.end_date),
                taskIndex: i,
                event
            };
        })
        .filter(t => t.inRange)
        .map(t => {
            const { taskIndex, event } = t;
            return {
                ...event,
                index: taskIndex
            };
        });
};

export const selectEventsForDayRange = createSelector(
    [selectDayRange, selectTracks],
    (dayRange, tracks) => {
        let result = [];

        for (let i = 0; i < tracks.length; ++i) {
            const track = tracks[i];
            let trackEvents = [];
            let children = [];

            if (track.tasks) {
                trackEvents = getDayRangeFilteredEventsForTasks(dayRange, track.tasks);
            }

            if (track.children) {
                for (let j = 0; j < track.children.length; ++j) {
                    const child = track.children[j];
                    let childEvents = [];
                    if (child.tasks) {
                        childEvents = getDayRangeFilteredEventsForTasks(dayRange, child.tasks);
                    }

                    children.push({
                        events: childEvents,
                        name: child.name,
                        type: child.type
                    });
                }
            }

            result.push({
                events: trackEvents,
                children,
                name: track.name,
                type: track.type
            });
        }
        return result;
    }
);

const checkOverlapsForEvents = (events, weekCount) => {
    let maxOverlaps = 0;
    let maxRowNumber = 0;

    for (let i = 1; i <= weekCount * 7; ++i) {
        let overlaps = 0;

        for (let j = 0; j < events.length; ++j) {
            const event = events[j];

            if (event.start < i && event.end >= i) {
                overlaps++;
            }
        }

        if (overlaps > maxOverlaps) {
            maxOverlaps = overlaps;
        }
    }

    for (let j = 0; j < events.length; ++j) {
        const event = events[j];

        if (event.row > maxRowNumber) {
            maxRowNumber = event.row;
        }
    }

    if (maxRowNumber > maxOverlaps) {
        maxOverlaps = maxRowNumber;
    }

    if (maxOverlaps < 1) {
        maxOverlaps = 1;
    }
    return maxOverlaps;
};

const checkEventsForAgendaDrag = (events, agendaItemPosition) => {
    if (agendaItemPosition === false) {
        return 0;
    }

    if (events) {
        for (let i = 0; i < events.length; ++i) {
            if (
                agendaItemPosition.index >= events[i].start - 1 &&
                agendaItemPosition.index <= events[i].end
            ) {
                return 1;
            }
        }
    }

    return 0;
};
export const selectStackedEventsForDayRange = createSelector(
    [selectEventsForDayRange, selectAgendaItemPosition, selectWeekCount],
    (dayRangeEvents, agendaItemPosition, weekCount) => {
        for (let i = 0; i < dayRangeEvents.length; ++i) {
            const parentTrack = dayRangeEvents[i];
            const overlaps = checkOverlapsForEvents(parentTrack.events, weekCount);

            let ol = 0;

            if (agendaItemPosition !== false && agendaItemPosition.childTrackIndex === false) {
                ol = checkEventsForAgendaDrag(parentTrack.events, agendaItemPosition);
            }
            dayRangeEvents[i].overlaps = overlaps + ol;

            if (dayRangeEvents[i].children) {
                for (let j = 0; j < dayRangeEvents[i].children.length; ++j) {
                    const events = dayRangeEvents[i].children[j].events;
                    const over = checkOverlapsForEvents(events, weekCount);

                    let ola = 0;

                    if (
                        agendaItemPosition !== false &&
                        agendaItemPosition.childTrackIndex !== false &&
                        agendaItemPosition.childTrackIndex === j
                    ) {
                        ola = checkEventsForAgendaDrag(events, agendaItemPosition);
                    }

                    dayRangeEvents[i].children[j].overlaps = over + ola;
                }
            }
        }

        return dayRangeEvents;
    }
);

export const selectDateForClickedTimeBlock = createSelector(
    [selectClickedTimeBlock, selectSelectedDays],
    (timeBlock, selectedDays) => {
        const date = selectedDays[timeBlock.column - 1];
        return date;
    }
);

export const selectJobpackNamesForAddEventList = createSelector(
    [selectJobpacks],
    jobpacks => {
        if (!jobpacks) {
            return [];
        }

        const list = Object.keys(jobpacks).map(e => {
            return jobpacks[e]["profile"].job_name;
        });

        return list;
    }
);

export const selectJobpackKeys = createSelector(
    [selectJobpacks],
    jobpacks => {
        if (!jobpacks) {
            return [];
        }

        const list = Object.keys(jobpacks).map(e => {
            return e;
        });

        return list;
    }
);

export const selectResourceForClickedTimeblock = createSelector(
    [selectClickedTimeBlock, selectUsers, selectEquipment, selectMachines, selectJobpacks],
    (timeblock, users, equipment, machines, jobpacks) => {
        const type = timeblock.type;

        switch (type) {
            case "machines": {
                return {
                    path: "/subjects/machines",
                    data: machines,
                    type: "machines"
                };
            }
            case "equipment": {
                return {
                    path: "/subjects/equipment",
                    data: equipment,
                    type: "equipment"
                };
            }
            case "employees": {
                return {
                    path: "/users",
                    data: users,
                    type: "employees"
                };
            }
            case "jobpack": {
                return {
                    path: false,
                    data: jobpacks,
                    key: false,
                    type: "jobpack"
                };
            }
            default: {
                return false;
            }
        }
    }
);

export const selectResourceNamesForAddEventList = createSelector(
    [selectResourceForClickedTimeblock],
    resource => {
        if (
            resource.path === false ||
            resource === false ||
            resource.data === false ||
            typeof resource.data === "undefined" ||
            resource.data === null
        ) {
            return false;
        }

        const result = Object.keys(resource.data).map(e => {
            const profile = resource.data[e]["profile"];

            switch (resource.type) {
                case "employees": {
                    return `${profile["first_name"]} ${profile["last_name"]}`;
                }
                case "machines": {
                    return `${profile["machine_desc"]}`;
                }
                case "equipment": {
                    return `${profile["description"]}`;
                }
                default: {
                    return "";
                }
            }
        });

        return result;
    }
);

export const selectResourceKeys = createSelector(
    [selectResourceForClickedTimeblock],
    resource => {
        if (!resource || !resource.data) {
            return [];
        }

        const list = Object.keys(resource.data).map(e => {
            return e;
        });

        return list;
    }
);

export const selectProfileForFocussedEvent = createSelector(
    [selectFocussedEvent, selectUsers, selectMachines, selectEquipment, selectJobpacks],
    (focussedEvent, users, machines, equipment, jobpacks) => {
        if (focussedEvent === false) {
            return false;
        }

        let profile = {};
        if (focussedEvent.type !== "jobpack") {
            const uid = focussedEvent.resource_key.split("/").pop();

            switch (focussedEvent.type) {
                case "machines": {
                    profile = machines[uid].profile;
                    break;
                }
                case "employees": {
                    profile = users[uid].profile;
                    break;
                }
                case "equipment": {
                    profile = equipment[uid].profile;
                    break;
                }

                default:
                    break;
            }
        } else {
            profile = jobpacks[focussedEvent.jobpack_key].profile;
        }

        return profile;
    }
);

export const selectAgendaForFocussedDay = createSelector(
    [
        selectClickedDayTimeBlock,
        selectTracks,
       
    ],
    (clickedDay, tracks) => {
        const date = moment(clickedDay, "ddd Do MMM");
        let result = [];
        for (let i = 0; i < tracks.length; ++i) {
            let trackEvents = [];

            if (Array.isArray(tracks[i].tasks)) {
                for (let j = 0; j < tracks[i].tasks.length; ++j) {
                    const start = moment(tracks[i].tasks[j]["start_date"], "DD/MM/YYYY");
                    const end = moment(tracks[i].tasks[j]["end_date"], "DD/MM/YYYY");

                    if (start <= date && end >= date) {
                        trackEvents.push(tracks[i].tasks[j]);
                    }
                }
            }

            const { children, tasks, trackCount, ...rest } = tracks[i];
            const theChildren = [];

            if (Array.isArray(children)) {
                for (let j = 0; j < children.length; ++j) {
                    const { trackCount, ...rest } = children[j];
                    const childTasks = children[j].tasks;
                    const theChildTasks = [];
                    if (Array.isArray(childTasks)) {
                        for (let k = 0; k < childTasks.length; ++k) {
                            const start = moment(childTasks[k]["start_date"], "DD/MM/YYYY");
                            const end = moment(childTasks[k]["end_date"], "DD/MM/YYYY");
                            if (start <= date && end >= date) {
                                theChildTasks.push(childTasks[k]);
                            }
                        }
                    }

                    const child = {
                        ...rest,
                        tasks: theChildTasks
                    };

                    theChildren.push(child);
                }
            }
            const track = {
                ...rest,
                tasks: trackEvents,
                children: theChildren
            };

            result.push(track);
        }
        return result;
    }
);

export const selectEquipmentForFocussedDay = createSelector(
    [selectAgendaForFocussedDay, selectEquipment],
    (agendaIn, equipment) => {
        if (typeof equipment === "undefined" || equipment === null) {
            return null;
        }
        let occupied = [];
        const agenda = JSON.parse(JSON.stringify(agendaIn));

        const result = agenda.map(track => {
            if (track.children) {
                track.children = track.children.filter(c => c.type === "equipment");

                track.children.map(child => {
                    if (child.tasks) {
                        child.tasks.map(t => {
                            occupied.push({
                                [t.resource_key.split("/").pop()]: t
                            });
                            return t;
                        });
                    }
                    return child;
                });
            }
            return track;
        });

        occupied = occupied.sort((a, b) => {
            return Object.keys(a)[0] < Object.keys(b)[0];
        });

        let userKeys = new Set(Object.keys(equipment));
        const occupiedKeys = [...new Set(occupied.map(e => Object.keys(e)[0]))];

        for (let i = 0; i < occupiedKeys.length; ++i) {
            userKeys.delete(occupiedKeys[i]);
        }

        userKeys = [...new Set(userKeys)];

        const usernames = userKeys.map(e => {
            return { name: `${equipment[e].profile.description}`, key: e };
        });

        occupied = occupiedKeys.map(e => {
            return { name: `${equipment[e].profile.description}`, key: e };
        });

        return { tasks: result, unoccupied: usernames, occupied };
    }
);

export const selectMachinesForFocussedDay = createSelector(
    [selectAgendaForFocussedDay, selectMachines],
    (agendaIn, machines) => {
        if (typeof machines === "undefined" || machines === null) {
            return null;
        }
        let occupied = [];
        const agenda = JSON.parse(JSON.stringify(agendaIn));

        const result = agenda.map(track => {
            if (track.children) {
                track.children = track.children.filter(c => c.type === "machines");

                track.children.map(child => {
                    if (child.tasks) {
                        child.tasks.map(t => {
                            occupied.push({
                                [t.resource_key.split("/").pop()]: t
                            });
                            return t;
                        });
                    }
                    return child;
                });
            }
            return track;
        });

        occupied = occupied.sort((a, b) => {
            return Object.keys(a)[0] < Object.keys(b)[0];
        });

        let userKeys = new Set(Object.keys(machines));
        const occupiedKeys = [...new Set(occupied.map(e => Object.keys(e)[0]))];

        for (let i = 0; i < occupiedKeys.length; ++i) {
            userKeys.delete(occupiedKeys[i]);
        }

        userKeys = [...new Set(userKeys)];

        const usernames = userKeys.map(e => {
            return { name: `${machines[e].profile.machine_desc}`, key: e };
        });

        occupied = occupiedKeys.map(e => {
            return { name: `${machines[e].profile.machine_desc}`, key: e };
        });

        return { tasks: result, unoccupied: usernames, occupied };
    }
);

export const selectEmployeesForFocussedDay = createSelector(
    [selectAgendaForFocussedDay, selectUsers],
    (agendaIn, users) => {
        const agenda = JSON.parse(JSON.stringify(agendaIn));
        let occupied = [];
        const result = agenda.map(track => {
            if (track.children) {
                track.children = track.children.filter(c => c.type === "employees");

                track.children.map(child => {
                    if (child.tasks) {
                        child.tasks.map(t => {
                            occupied.push({
                                [t.resource_key.split("/").pop()]: t
                            });
                            return t;
                        });
                    }
                    return child;
                });
            }
            return track;
        });

        occupied = occupied.sort((a, b) => {
            return Object.keys(a)[0] < Object.keys(b)[0];
        });

        let userKeys = new Set(Object.keys(users));
        const occupiedKeys = [...new Set(occupied.map(e => Object.keys(e)[0]))];

        for (let i = 0; i < occupiedKeys.length; ++i) {
            userKeys.delete(occupiedKeys[i]);
        }

        userKeys = [...new Set(userKeys)];

        const usernames = userKeys.map(e => {
            return {
                name: `${users[e].profile.first_name} ${users[e].profile.last_name}`,
                key: e
            };
        });

        occupied = occupiedKeys.map(e => {
            return {
                name: `${users[e].profile.first_name} ${users[e].profile.last_name}`,
                key: e
            };
        });

        return { tasks: result, unoccupied: usernames, occupied };
    }
);

export const selectChildEventsForParentEventView = (parentTrackIndex, eventIndex) => {
    return createSelector(
        [selectEventsForDayRange],
        allEvents => {
            const trackEvents = allEvents[parentTrackIndex];
            const event = trackEvents.events[eventIndex];
            const children = trackEvents.children;

            let allEmployeeEvents = [];
            let allMachinesEvents = [];
            let allEquipmentEvents = [];

            const getEventsForParentTrack = events => {
                events = JSON.parse(JSON.stringify(events));
                events = events.filter(
                    e =>
                        !(e.end <= event.start) &&
                        !(e.start >= event.end) &&
                        e.jobpack_key === event.jobpack_key
                );

                const set = {};
                for (let i = 0; i < events.length; ++i) {
                    set[events[i].row] = Array.isArray(set[events[i].row])
                        ? set[events[i].row]
                        : [];
                    set[events[i].row].push(events[i]);
                }

                events = [];
                Object.keys(set).map((e, i) => {
                    set[e] = set[e].map(f => {
                        f.row = i + 1;
                        return f;
                    });

                    events = [...events, ...set[e]];
                    return e;
                });

                events = events.map(e => {
                    if (e.start < event.start) {
                        e.start = event.start;
                    }

                    if (e.end > event.end) {
                        e.end = event.end;
                    }

                    e.end = e.end - event.start;
                    e.start = e.start - event.start;

                    return e;
                });

                events.rowCount = Object.keys(set).length;

                return events;
            };

            let employeeRowCount = 0;
            let machinesRowCount = 0;
            let equipmentRowCount = 0;

            children.map(c => {
                const evs = getEventsForParentTrack(c.events);
                switch (c.type) {
                    case "equipment": {
                        equipmentRowCount += evs.rowCount;
                        allEquipmentEvents.push(evs);
                        break;
                    }
                    case "employees": {
                        employeeRowCount += evs.rowCount;
                        allEmployeeEvents.push(evs);
                        break;
                    }
                    case "machines": {
                        machinesRowCount += evs.rowCount;

                        allMachinesEvents.push(evs);
                        break;
                    }
                    default:
                        break;
                }
                return c;
            });

            const allChildEvents = [
                ...allEmployeeEvents,
                ...allMachinesEvents,
                ...allEquipmentEvents
            ];

            let rowAdder = 0;
            let returnArray = [];

            for (let i = 0; i < allChildEvents.length; ++i) {
                for (let j = 0; j < allChildEvents[i].length; ++j) {
                    allChildEvents[i][j].row += rowAdder;
                    returnArray.push(allChildEvents[i][j]);
                }

                rowAdder += allChildEvents[i].rowCount;
            }

            return {
                events: returnArray,
                rowCounts: { employeeRowCount, equipmentRowCount, machinesRowCount }
            };
        }
    );
};

export const selectTrackHeight = (parentTrackIndex, childTrackIndex) => {
    return createSelector(
        [selectTracks],
        tracks => {
            if (childTrackIndex === false) {
                return tracks[parentTrackIndex].height;
            } else {
                return tracks[parentTrackIndex].children[childTrackIndex].height;
            }
        }
    );
};

export const selectParentTrackOpen = parentTrackIndex => {
    return createSelector(
        [selectTracks],
        tracks => {
            if (typeof tracks[parentTrackIndex] === "undefined") {
                return null;
            }
            return tracks[parentTrackIndex].open;
        }
    );
};
